export const SERVICE_LIGHT_TYPE = 'Service Light'; // Used for specifics products like Gift Card
export const FIRST_ORDER_GIFT = 'first-order-gift';
export const ALCOHOL_TYPE = 'Alcools';
export const SECTIONS = {
  RECOMMENDATIONS: 'recommendations',
  ABOUT: 'about',
  COMPOSITION: 'composition',
  VENDOR: 'vendor',
  TIPS: 'tips',
  REVIEWS: 'reviews',
};
